import { createStore } from 'vuex'

export default createStore({
  state() {
    return {
      appIsStarting: true, // этот статус:
      // 1. Нужен, чтобы при старте SPA, не мелькнула LoginForm (при медленом Интернете), например, в CatalogView.
      // 2. Чтобы показывать Loader когда приложение стартует.
      // 3. Используя appIsStarting вместо isAuthLoading, не скрываем LoginForm когда идет проверка пароля
      isAuth: false,
      language: '',
      products: [],
      isProdsLoading: false,
      sortSelected: '',
      page: 1,
      totalPages: 0,
      notifyList: [],
      newProd: {
        id: 0,
        price: 1,
        pictures: [],
        brand: '',
        model: '',
        brand2: '',
        model2: '',
      },
      updProd: {
        id: 0,
        price: 1,
        pictures: [],
        brand: '',
        model: '',
        brand2: '',
        model2: '',
      },
      updProdFreeze: false, // нужно только для мультиязычного сайта
      // Чтобы в FormEdit.vue при переключениии языка (при медленом Интернет соединении) отображался Loader и не проскакивало сообщение типа "Описание товара на этом языке отсутствует". Кроме того, на  странице FormEdit нельзя обойтись isProdsLoading для управления отображением, поскольку isProdsLoading будет false раньше updProdFreeze (раньше времени)
      // freeze: false,
    }
  },

  getters: {
    language(state) {
      return state.language
    },
    products(state) {
      if(!state.products.length) return
      return state.products
    },
    getPicsInDB(state) {
      if(!state.updProd.pictures) state.updProd.pictures = []
        return state.updProd.pictures
    },
  },

  mutations: {
    SetAppIsStarting(state, value) {
      state.appIsStarting = value
    },

    SetIsAuth(state, value) {
      state.isAuth = value
    },

    SetLanguage(state, value) {
      state.language = value
    },

    SetProducts(state, value) {
      state.products = value
    },

    SetIsProdsLoading(state, value) {
      state.isProdsLoading = value
    },

    SetTotalPages(state, value) {
      state.totalPages = value
    },

    SetPage(state, value) {
      state.page = value
    },

    SetSortSelected(state, value) {
      state.sortSelected = value
    },

    // AddProduct(state) {
    //   state.products.push({...state.newProd})
    // },

    SetUpdId(state, value) {
      state.updProd.id = value
    },

    SetUpdProd(state, [ id, price, pictures, brand, model ]) {
      state.updProd.id = id
      state.updProd.price = price
      state.updProd.pictures = pictures
      state.updProd.brand = brand
      state.updProd.model = model
    },

    SetUpdProdFreeze(state, value) {
      state.updProdFreeze = value
    },

    SetUpdProdTranslation(state, [ brand2, model2 ] ) {
      state.updProd.brand2 = brand2
      state.updProd.model2 = model2
    },

    UpdatePicsInDB(state, newPicsArray) {
      state.updProd.pictures = newPicsArray
    },
    // Возврат элементов из picsToDelete в стор pictures
    AddToPicsInDB(state, newPicsArray) {
      state.updProd.pictures = [...state.pictures, ...newPicsArray]
    },

    ClearUpdProd(state) {
      state.updProd.id = 0
      state.updProd.price = 1
      state.updProd.pictures = []
      state.updProd.brand = ''
      state.updProd.model = ''
      state.updProd.brand2 = ''
      state.updProd.model2 = ''
    },

    ClearNewProd(state) {
      state.newProd.price = 1
      state.newProd.brand = ''
      state.newProd.model = ''
      state.newProd.brand2 = ''
      state.newProd.model2 = ''
    },
   
    DelNotify(state, id) {
      state.notifyList = state.notifyList.filter(value => value.id !== id);
    },

    AddNotify(state, notify) {
      state.notifyList = [notify, ...state.notifyList]
    },

    SetNewId(state, value) {
      state.newProd.id = value
    },

    SetNewPictures(state, value) {
      state.newProd.pictures = value
    },

    SetNewPrice(state, value) {
      state.newProd.price = value
    },

    SetNewBrand(state, event) {
      state.newProd.brand = event.target.value
    },

    SetNewModel(state, event) {
      state.newProd.model = event.target.value
    },

    SetUpdBrand(state, event) {
      state.updProd.brand = event.target.value
    },

    SetUpdModel(state, event) {
      state.updProd.model = event.target.value
    },

    SetUpdPrice(state, value) {
      state.updProd.price = value
    },

    // // Заморозка
    // SetFreeze(state, value) {
    //   state.freeze = value
    // },
  },

  actions: {
    SaveLanguage(state, value) {
      localStorage.setItem('language', value)
      state.commit('SetLanguage', value);
    },
  },

  // modules: {
  // }
})